var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.429,
    height: 11.427,
    viewBox: "0 0 25.429 11.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#45338c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M409.3,1531.145a1.214,1.214,0,0,1-.822,1.075c-.655.2-1.312.4-1.951.64s-1.267.542-1.9.815a.151.151,0,0,1-.085.021c-.79-.224-1.4.316-2.092.507-.974.27-1.917.657-2.869,1q-1.3.473-2.58.975c-.173.068-.31.219-.479.3-.315.159-.656.272-.959.45-.638.372-1.254.779-1.887,1.159-.7.421-1.407.826-2.108,1.244-.081.048-.133.142-.21.2-.148.109-.3.295-.458.294a4.239,4.239,0,0,0-1.809.711c-.657.31-1.307.634-1.961.952-.306.149-.61.3-.92.443-.089.041-.21.095-.286.065a2.79,2.79,0,0,1-1.544-.954c-.66-.96-.467-1.995-.507-3.013a4.558,4.558,0,0,1,.169-1.347.919.919,0,0,1,1.34-.45,3.3,3.3,0,0,1,1.258,1.48c.176.417.486.6.879.414.7-.333,1.388-.709,2.079-1.069.038-.02.065-.088.1-.088.673.009,1.018-.6,1.568-.836.533-.229.994-.619,1.511-.893.781-.413,1.569-.819,2.38-1.167.915-.393,1.857-.726,2.792-1.07a21.7,21.7,0,0,0,2.461-.9,8.016,8.016,0,0,1,2.243-.61c.567-.11,1.116-.318,1.684-.417,1.007-.177,2.021-.318,3.035-.446.409-.052.831,0,1.242-.045C409.125,1530.544,409.3,1530.665,409.3,1531.145Z",
    transform: "translate(-383.873 -1530.585)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick3);
export default __webpack_public_path__ + "static/media/tick-3.96c99d42d32090bd182d562081bcfa4e.svg";
export { ForwardRef as ReactComponent };